import { CheckBadgeIcon, PlusCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { useMemo } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { v4 as uuidv4 } from "uuid";
import cleanDeep from "clean-deep";
import { Actions as REPORTACTIONS } from "../../../store/actions/reportActions";

const ReportPackModal = ({ reportPacks, saveReportPacks }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [pack, setPack] = useState({});

	const updateField = (field, value) => {
		if (!field) return;

		const newPack = { ...pack };

		newPack[field] = value;

		setPack(newPack);
	};

	const submit = () => {
		if (!pack?.name)
			return NotificationManager.error(
				"Please ensure all required fields are filled before submitting!",
				"Create Report Pack",
			);

		const newReportPacks = [...reportPacks];

		const cleanedPack = cleanDeep(pack);

		const dataToSubmit = {
			id: uuidv4(),
			reports: [],
			appliedOrgs: [],
			...cleanedPack,
		};

		newReportPacks.push(dataToSubmit);

		saveReportPacks(newReportPacks);

		NotificationManager.success("Report Pack created successfully!", "Create Report Pack");

		setIsOpen(false);
	};

	//Restore to defaults when modal is opened
	useMemo(() => {
		if (!isOpen) return;

		setPack({});
	}, [isOpen]);

	return (
		<>
			<button
				className="btn btn-success pull-right"
				type="button"
				id="add-report-pack"
				onClick={() => setIsOpen(true)}
			>
				<PlusCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
				<div style={{ float: "left" }}>Create Pack</div>
			</button>
			<div
				className="modal"
				tabIndex="-1"
				role="dialog"
				aria-hidden={!isOpen}
				style={{
					visibility: isOpen ? "visible" : "hidden",
					display: "block",
					background: "rgba(0,0,0,0.4)",
					overflow: "scroll",
					transition: "opacity 0.5s ease-in-out, visibility 0.5s ease-in-out",
					opacity: isOpen ? 1 : 0,
					pointerEvents: isOpen ? "auto" : "none",
				}}
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<div
							className="block block-themed block-transparent remove-margin-b"
							style={{ padding: 0 }}
						>
							<div
								className="block-header bg-primary-dark"
								style={{ padding: 20 }}
							>
								<ul className="block-options">
									<li>
										<button
											type="button"
											onClick={() => setIsOpen(false)}
										>
											<XMarkIcon className="h-6 w-6 mr-3 text-white" />
										</button>
									</li>
								</ul>
								<h3 className="block-title text-white">Create Report Pack</h3>
							</div>
							<div
								className="block-content"
								style={{ padding: 20 }}
							>
								<div className="col-sm-12 p-0 form-material">
									<div className="col-xs-6 pl-0">
										<div className="form-material form-container">
											<label>Name*</label>
											<input
												className="form-control form-input"
												value={pack?.name || ""}
												onChange={(e) => {
													updateField("name", e.target.value);
												}}
												autoComplete="off"
											/>
										</div>
									</div>
								</div>
								<div className="col-sm-12 p-0 pb-5">
									<div
										className="btn btn-success pull-right"
										onClick={submit}
									>
										<CheckBadgeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
										<span style={{ float: "left" }}>Submit</span>
									</div>
									<div
										className="btn btn-danger pull-right"
										style={{ marginRight: 5 }}
										onClick={() => setIsOpen(false)}
									>
										Cancel
									</div>
								</div>
							</div>
							<div className="clearfix" />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => ({
	saveReportPacks: (data) => dispatch(REPORTACTIONS.postReportPacks(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportPackModal);
